import ewbApi from "network/ewbApi";
import { DXP_LANDING } from "network/endpoints";

export const getMain = async () => ewbApi.get(DXP_LANDING.main);

export const getFeatures = async (ids: string) =>
  ewbApi.get(`${DXP_LANDING.features}${ids}`);

export const getFaqs = async (ids: string) =>
  ewbApi.get(`${DXP_LANDING.faqs}${ids}`);

export const getUserGuide = async (ids: string) =>
  ewbApi.get(`${DXP_LANDING.userGuide}${ids}`);

export const getRegStep = async (ids: string) =>
  ewbApi.get(`${DXP_LANDING.regStep}${ids}`);

export const getFaqItems = async (ids: string) =>
  ewbApi.get(`${DXP_LANDING.faqQuestions}${ids}`);
